/**
 * @file PageLayout.tsx
 * @description Shared page layout with header, footer, and main content container.
 */

import type { ReactNode } from 'react'
import { SiteHeader } from './SiteHeader'
import { SiteFooter } from './SiteFooter'

/**
 * Props for the PageLayout component.
 */
interface PageLayoutProps {
  /** Main page content rendered between header and footer. */
  children: ReactNode
}

/**
 * PageLayout component composes the global shell used across all pages.
 */
export function PageLayout({ children }: PageLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col bg-slate-950 text-slate-50">
      <SiteHeader />
      <main className="flex-1 pt-20">
        {children}
      </main>
      <SiteFooter />
    </div>
  )
}
